import { NgIf, AsyncPipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CartActions, CartLine } from '@next/core-lib/cart';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData, DIALOG_RETURN_TYPES, AgrDialogModule } from '@next/core-lib/dialog';
import { LocaleService, AgrI18nSharedModule } from '@next/core-lib/i18n';
import { SelectedCustomer, UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

interface RemarksComponentData extends AbstractDialogData {
  cartLine: CartLine;
  cartId: number;
}

@Component({
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss'],
  imports: [AgrDialogModule, NgIf, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, AsyncPipe, AgrI18nSharedModule],
})
export class RemarksComponent extends AbstractDialog<RemarksComponentData> implements OnInit {
  remarksGroup = new FormGroup({
    remarks: new FormControl(this.data.cartLine.remarks, []),
  });
  public isNlSalesOrganization$: Observable<boolean>;
  private cartLine: CartLine;
  private cartId: number;
  private readonly customer$: Observable<SelectedCustomer>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RemarksComponentData,
    protected readonly mdDialogRef: MatDialogRef<RemarksComponent, AbstractDialogResultData<RemarksComponentData>>,
    private readonly localeService: LocaleService,
    private readonly store: Store,
  ) {
    super();
    this.cartLine = this.data.cartLine;
    this.cartId = this.data.cartId;
    this.customer$ = this.store.select(UserSelectors.selectCustomer);
  }

  ngOnInit(): void {
    this.isNlSalesOrganization$ = this.customer$.pipe(
      map((selectedCustomer) => selectedCustomer?.shipTos[0]?.salesAreas[0]?.salesOrganization),
      map((salesOrganization) => salesOrganization?.startsWith('NL') || false),
    );

    this.data.title = this.localeService.translate('cart.cart-column-remarks');
    this.data.confirmButtonText = this.localeService.translate('cart.cart-remarks-dialog.confirm');
    this.data.confirmButton = true;
  }

  cancel(): void {
    this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.cancel });
  }

  addRemarks(): void {
    this.store.dispatch(
      CartActions.updateCartLineRemarks({
        cartId: this.cartId,
        cartLineId: this.cartLine?.id,
        remarks: this.remarksGroup.value.remarks,
      }),
    );
    this.confirm();
  }
}
